import gen from "@/functions/general.js"
import {apiDateString} from "@/api/apicommon"


export function createChartDataForAssessed(allExpressions, assessmentExpr) {
  if (!allExpressions) {return []}
  if (!assessmentExpr) {return []}
  if (assessmentExpr.expressionType === "SubstanceAdministrationPrescription") {return []}

  const allMatchingProxies = allExpressions.filter(expr => expr.sctProxyKey === assessmentExpr.sctProxyKey)

  //Get numerical chart expressions for the assessmentExpr
  let chartExpressions = allMatchingProxies.filter(expr => expr.standardizedNumerical !== "")
  
  //If no standaradized ucumUnit (meaning no sctUcumData in Backend), match on same ucumUnit (no unit conversion)
  if (!chartExpressions.length) {
    chartExpressions = allMatchingProxies.filter(expr => {return (
      expr.numericalValue !== "" && expr.sctUnit !== "" && expr.ucumUnit === assessmentExpr.ucumUnit
    )})
  }

  //Work on Data
  chartExpressions = gen.deepCopy(chartExpressions)
  for (const chartExpression of chartExpressions) {
    chartExpression.entryDate = apiDateString(chartExpression.entry.entryStart)
    chartExpression.chartDate = new Date(chartExpression.timelineStart).getTime()
  }
  chartExpressions.sort((a, b) => a.chartDate - b.chartDate);

  //Return
  return chartExpressions
}

export function createOption(chartData) {
  let valueData
  let chartUnit
  let lowerLimit
  let upperLimit
  
  if (chartData[0].standardizedNumerical && chartData[0].standardizedNumerical !== "") {
    valueData = chartData.map(item => [item.chartDate, item.standardizedNumerical, item.entryDate, item.originalText])
    lowerLimit = chartData[0].standardizedLowerLimit
    upperLimit = chartData[0].standardizedUpperLimit
    chartUnit = chartData[0].standardizedUnitTerm
  } else {
    valueData = chartData.map(item => [item.chartDate, item.numericalValue, item.entryDate, item.originalText])
    chartUnit = chartData[0].ucumUnit
  }
  
  const lineColor = "#3F48CC"
  const normalAreaColor = "#c8e6c9" 
  
  return {
    grid: {
      left: '10%',
      right: '0.7%',
      bottom: '10%',
      top: '10%',
      containLabel: false,
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
      axisLabel: {
        formatter: '{yyyy}',
        hideOverlap: true
      },
      minInterval: 3600 * 1000 * 24 * 365,
    },
    yAxis: {
      type: 'value',
      boundaryGap: false,
      name: chartUnit,
      nameLocation: "end",
      nameTextStyle: {
        align: "right",
        padding: [0, 7, -10, 0],
        overflow: 'truncate',
      },
      scale: false,
      min: 0,
      max: (value) => {
        const dataMax = value.max;
        const maxValue = upperLimit !== undefined ? Math.max(dataMax, upperLimit) : dataMax;
        return maxValue + (maxValue * 0.3);
      },      
      axisLabel: {
        showMinLabel: false,
        showMaxLabel: false,
        formatter: (value) => {
          return value.toLocaleString('fr-FR');
        }
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: params => {
        return (
          params.value[2] +
          '<br />' +
          '<span style="color: black;">' + params.value[3] + '</span>'
        );
      },
    },
    series: [
      {
        type: 'line',
        data: valueData,
        symbolSize: 6,
        itemStyle: {
          color: lineColor
        },
        label: {
          show: true,
          position: 'top',
          formatter: (params) => {
            const numValue = Number(params.value[1]);
            return numValue.toLocaleString('fr-FR');
          },
          color: lineColor,
          fontSize: 11,
          fontWeight: 'normal',
          distance: 5
        },
        emphasis: {
          scale: true,
          symbolSize: 12,
          itemStyle: {
            color: lineColor,
          }
        },
        markArea: lowerLimit !== undefined && upperLimit !== undefined ? {
          silent: true,
          itemStyle: {
            color: normalAreaColor
          },
          data: [[
            { yAxis: lowerLimit },
            { yAxis: upperLimit }
          ]]
        } : undefined
      },
    ],
    animation: false,
  }
}